import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';
import { surveyGetHandler, surveySendResultHandler } from './nps-methods-handlers';
import { MethodPropertiesKey } from '../../shared/consts';

export enum NpsMethods {
  SurveyGet = 'surveyGet',
  SurveySendResult = 'surveySendResult',
}

export const NPS_HANDLER_LIST: MethodHandler = {
  [NpsMethods.SurveyGet]: surveyGetHandler,
  [NpsMethods.SurveySendResult]: surveySendResultHandler,
};

export const NPS_PROPERTIES_LIST: MethodProperties = new Map([
  [
    NpsMethods.SurveyGet,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.SE,
      },
    ],
  ],
  [
    NpsMethods.SurveyGet,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.SE,
      },
    ],
  ],
]);
